<template>
  <div v-if="contract">
    <div class="field">
      <label class="label">ID</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="selectedContract.id"
          disabled
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Start</label>
      <div class="control">
        <input
          class="input"
          type="datetime-local"
          :value="formatDateForInput(contract.start_date)"
          @input="updateStartDate"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">End</label>
      <div class="control">
        <input
          class="input"
          type="datetime-local"
          :value="formatDateForInput(contract.end_date?.Time)"
          @input="updateEndDate"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Next Invoice</label>
      <div class="control">
        <input
          class="input"
          type="datetime-local"
          :value="formatDateForInput(contract.next_invoice_date?.Time)"
          @input="updateNextInvoiceDate"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">User Count</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="contract.features.user_count"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Snapshot Frequency (minutes)</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="contract.features.snapshot_frequency"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Camera Count</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="contract.features.camera_count"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Project Count</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="contract.features.project_count"
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Monthly Video Count</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="contract.features.monthly_video_count"
        />
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="checkbox">
          <input type="checkbox" v-model="contract.features.ai_detection" />
          AI Detection
        </label>
      </div>
    </div>
    <div class="field">
      <label class="label">Package</label>
      <div class="control">
        <div class="select">
          <select v-model="selectedContract.package_id">
            <option value="">Select Package</option>
            <option value="1">Basic</option>
            <option value="2">Pro</option>
            <option value="3">Enterprise</option>
          </select>
        </div>
      </div>
    </div>
    <div class="control">
      <span
        :class="[
          'select',
          contract.is_canceled === false ? 'is-success' : 'is-danger',
        ]"
      >
        <select v-model="contract.is_canceled">
          <option value="true">Canceled</option>
          <option value="false">Active</option>
        </select>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ContractGeneralTab",
  props: {
    contractData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["selectedContract"]),
    contract() {
      return this.contractData || this.selectedContract;
    },
  },
  methods: {
    formatDateForInput(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:mm
    },
    updateStartDate(event) {
      const date = event.target.value;
      if (date) {
        this.contract.start_date = date;
      }
    },
    updateEndDate(event) {
      const date = event.target.value;
      if (date) {
        this.contract.end_date = {
          Time: `${date}:00Z`,
          Valid: true,
        };
      }
    },
    updateNextInvoiceDate(event) {
      const date = event.target.value;
      if (date) {
        this.contract.next_invoice_date = {
          Time: `${date}:00Z`,
          Valid: true,
        };
      }
    },
  },
};
</script>

<style></style>
